export default __webpack_public_path__ + "static/media/email-parser-white.afbe1b96.png";